import { Listing } from "@/modules/property-tracks/types";
import { Box, Typography } from "@mui/material";
import ListingStatusItem from "./status";
import Status from "@/modules/common/components/ui-kit/status/status";

export default function ListingTopBar({
  listing,
  actions,
}: {
  listing: Listing;
  actions?: React.ReactNode;
}) {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        p: theme.nawy.spacing.md,
        backgroundColor: theme.nawy.colors.semantic.layer.primary,
        justifyContent: "space-between",
      })}
    >
      <Box
        sx={(theme) => ({
          display: "flex",
          gap: theme.nawy.spacing.xs,
          flex: 1,
          alignItems: "center",
        })}
      >
        <Typography
          sx={(theme) => theme.nawy.typography.english.variants.headline.sm}
        >
          Listing details
        </Typography>
        <ListingStatusItem status={listing.status} />
        {listing.isSold && 
        <Status
              label={"Sold Off"}
              variant={"secondary"}
              color={"red"}
              width="auto"
            />
            }
        
      </Box>
      <Box sx={(theme) => ({ display: "flex", gap: theme.nawy.spacing.xs })}>
        {actions}
      </Box>
    </Box>
  );
}
